import React from 'react';

interface LoaderProps {
  label: string;
  className?: string;
}

const Loader: React.FC<LoaderProps> = ({ label, className = '' }) => {
  const containerClassName = ['app-loader', className].filter(Boolean).join(' ');

  return (
    <div className={containerClassName} role="status" aria-live="polite">
      <div className="custom-loader" data-testid="loader-spinner" aria-hidden="true" />
      <span className="app-loader-label">{label}</span>
    </div>
  );
};

export default Loader;
